<template>
  <el-card class="box-card" body-style="padding: 0px">
    <div slot="header" class="clearfix">
      <el-button class="btn-plus" style="float: right" type="success" icon="el-icon-plus" @click="addNewMenuCoupon" v-if="permission.can('write', 'couponmaster')">
        新規登録する
      </el-button>
    </div>
    <div class="clearfix">
      <el-table :data="ownerMenuCoupons" border fit highlight-current-row style="width: 100%" @row-click="rowClicked" empty-text="該当結果が見つかりません。"
      >
        <el-table-column
            prop="id"
            label="ID"
            width="70px"
        />
        <el-table-column
            prop="name"
            label="回数券名"
            min-width="130px"
        >
        </el-table-column>
        <el-table-column
            prop="therapists"
            min-width="130px"
            sortable
            label="担当者"
        >
          <template slot-scope="scope">
            <div v-for="therapist in scope.row.therapists" :key="therapist.id" >
              {{therapist.name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="total_uses"
            min-width="130px"
            label="提供回数"
        />
        <el-table-column
            prop="duration"
            min-width="130px"
            label="提供時間(分)"
        >
          <template slot-scope="scope">
            {{ scope.row.duration || '' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="unitprice"
            min-width="130px"
            label="販売価格(税込)"
        >
          <template slot-scope="props">
            {{ `${props.row.unitprice.toLocaleString()}円` }}
          </template>
        </el-table-column>
        <el-table-column
            prop="tax_percent"
            min-width="130px"
            label="税率 (%)"
        >
          <template slot-scope="props">
            {{ props.row.tax_percent == 0 ? "非課税" : props.row.tax_percent }}
          </template>
        </el-table-column>
        <el-table-column
            prop="number_month_expired"
            label="有効期限"
        >
          <template slot-scope="props">
            {{ props.row.number_month_expired ? `${props.row.number_month_expired}ヶ月` : '' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import permissionService from "../../../services/permission_service";
export default {
  data() {
    return {
      permission: permissionService
    }
  },
  computed: {
    ...mapGetters(['ownerMenuCoupons', 'newMenuCoupon', 'queryMenuCoupon']),
    isValidTitle() {
      return this.queryMenuCoupon.isValid ? '回数券管理' : '消化済み回数券の管理'
    }
  },
  methods: {
    ...mapMutations('menu_coupon', ['SET_MENU_COUPON_VISIBLE', 'SET_EDIT_MENU_COUPON', 'SET_MENU_COUPON_IS_EDIT', 'SET_IS_VALID']),
    ...mapActions('menu_coupon', ['fetchOwnerMenuCoupons']),
    ...mapActions('therapist', ['fetchTherapists']),

    addNewMenuCoupon() {
      this.SET_MENU_COUPON_VISIBLE(true)
      this.SET_MENU_COUPON_IS_EDIT(false)
      this.SET_EDIT_MENU_COUPON(this.newMenuCoupon)
      document.body.classList.add('modal-open');
    },
    async rowClicked(row) {
      this.SET_MENU_COUPON_IS_EDIT(true)
      this.SET_EDIT_MENU_COUPON(row)
      await this.fetchTherapists(row.clinic.id)
      this.SET_MENU_COUPON_VISIBLE(true)
      document.body.classList.add('modal-open');
    },
    switchIsValid() {
      this.SET_IS_VALID(!this.queryMenuCoupon.isValid)
      this.fetchOwnerMenuCoupons()
    },
  }
}
</script>
<style>
th .cell, .el-table .sort-caret.ascending {
  color: #51cbce;
}
</style>
